/**
 * Pluck a query param from the location
 * @param {Array<string>} params The query string parameter to search for and remove.
 * @param {Object} location Location object with href property.
 * @param {Object} history History object with replaceState method.
 * @return {Object} The an object with matching params.
 */
export default function pluckQueryParams(
  params,
  replace = true,
  location = window.location,
  history = window.history,
) {
  const url = new URL(location.href);
  const searchParams = url.searchParams;

  const matches = {};
  for (const param of params) {
    if (searchParams.has(param)) {
      matches[param] = searchParams.get(param);
      searchParams.delete(param);
    }
  }

  if (replace) {
    history.replaceState(null, '', url.toString());
  }

  return matches;
}
